import { Component, inject } from '@angular/core';
import { IconDefinition } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm',
  standalone: false,
  styles: ``,
  templateUrl: './confirm.component.html',
})
export class ConfirmComponent {
  title: string | null = null;
  prompt: string = `Are you sure?`;
  cancelBtnClass: string = 'btn-outline-gray';
  okBtnClass: string = 'btn-primary';
  cancelBtnText: string = `Cancel`;
  okBtnText: string = `Yes`;
  cancelBtnIcon: IconDefinition | null = null;
  okBtnIcon: IconDefinition | null = null;

  private modal = inject(NgbActiveModal);

  ngOnInit(): void {
  }

  confirmModal(): void {
    this.modal.close();
  }

  dismissModal(): void {
    this.modal.dismiss();
  }
}
